import * as Consts from '../../components/constants/Consts';
import store from '../../redux/store';
import * as AuthRoute from './SecurityAuthRoute';
import { RoleClient, RoleSystem, ClientType } from '../../components/constants/Consts';


export const getSignedInUser = () => {
    const signedInUser = store.getState().auth.afUser;

    return signedInUser;
}


export const getSignedInUserRole = () => {
    const signedInUser = store.getState().auth.afUser;

    return signedInUser.generalSection.role;
}


export const isSignedInUserInRole = (checkRole) => {
    const signedInUser = store.getState().auth.afUser;

    return signedInUser.generalSection.role === checkRole;
}


export const isSystemUser = () => {
    const userRole = store.getState().auth.afUser.generalSection.role;

    if(userRole === RoleSystem.Admin || userRole === RoleSystem.User) {
        return true;
    }
    else {
        return false;
    }
}
 
/*
 * Returns true if the signed in user belongs to an employer
 * Returns false if the signed in user bolongs to a service provider
 * Returns false if the signed in user bolongs to Corevo
 */
export const isUserOfClientEmployer = () => {
    const signedInUser = store.getState().auth.afUser;

    var userBelongsToEmployer = false;
    if(signedInUser.generalSection.clientType === ClientType.Angajator) {
        userBelongsToEmployer = true;
    }

    return userBelongsToEmployer;
}


/**
 * Returns null if the user has full authorization
 * 
 * TODO - check the roles
 */
export const getAuthorizedClient = () => {
    const signedInUser = store.getState().auth.afUser;

    var authzClient;
    if(signedInUser.generalSection.clientId === Consts.COREVO_CLIENT_ID) {
        authzClient = null;
    }
    else{
        authzClient = signedInUser.generalSection.clientId;
    }

    return authzClient;
}


export const getAuthorizedEmployersAsRestrictedUser = () => {
    const signedInUser = store.getState().auth.afUser;

    var authzEmployers;
    if(signedInUser.generalSection.role === RoleClient.UserSpecificEmployer) {
        authzEmployers = !!signedInUser.generalSection.permissionedER ? signedInUser.generalSection.permissionedER : [];
    }
    else{
        authzEmployers = null;
    }

    return authzEmployers;
}


/*
 * Returns null if the user is authorized for all worksites
 *  - this means all worksites of the cient + the ones that are subcontracted from other clients
 * 
 * Returns a subset otherwise
 *   - in case of Restricted users
 */
export const getAuthorizedWorksitesForContextClient = () => {
    var authzWorksites = null;

    const signedInUser = store.getState().auth.afUser;

    if(signedInUser.generalSection.role === RoleClient.UserSpecificEmployer) {
        authzWorksites = !!signedInUser.generalSection.permissionedWS ? signedInUser.generalSection.permissionedWS :[];
        // authzWorksites = authzWorksites.map(wsId => parseInt(wsId))
        authzWorksites = authzWorksites
                            .filter(wsKeyId => wsKeyId.includes('#'))
                            .map(wsKeyId => parseInt(wsKeyId.split('#')[1]))
    }
    else{
        authzWorksites = null;
    }

    return authzWorksites;
}


/*
 * Returns null if the user is authorized for all worksites 
 * Returns a subset otherwise
 *  - For Restricted users - returns the permissiond worksites
 *  - For Regular users - returns the permissioned WS from subcontracting for another user.
 *  - For Admin Users (on behalf of a client) - returns the permissioned WS from subcontracting for another user.
 * 
 */
export const getAuthorizedWorksitesForEmployer = (employerId) => {
    var authzWorksites;

    if(isSystemUser()) {
        // System users act 'on behalf' of the context client 
        // Should we check if loaded successfully
        const subcontractedClients = store.getState().clientSubcontracted.clientSubcontracted;
        authzWorksites = getEmployerWsFromSubcontracted(subcontractedClients, employerId);
    }
    else{
        const signedInUser = store.getState().auth.afUser;
        if(signedInUser.generalSection.role != RoleClient.UserSpecificEmployer) {
            const subcontractedClients = store.getState().auth.subcontracted;
            authzWorksites = getEmployerWsFromSubcontracted(subcontractedClients, employerId);
        }
        else {
            const authzsWs = !!signedInUser.generalSection.permissionedWS ? signedInUser.generalSection.permissionedWS : [];
            // authzWorksites = authzsWs.map(wsId => parseInt(wsId))
            const erKeyPart = employerId + '#';
            authzWorksites = authzsWs
                                .filter(wsKeyId => wsKeyId.startsWith(erKeyPart))
                                .map(wsKeyId => parseInt(wsKeyId.split('#')[1]))
        }
    }

    return authzWorksites;
}

const getEmployerWsFromSubcontracted = (subcontractedClients, employerId) => {
    var worksites;

    const subcon = subcontractedClients.find(subcon => subcon.generalSection.permissionedER.includes(employerId))
    if(subcon) {
        // The employer belongs to a client that the current user is subcontracting for
        const authzsWs = !!subcon.generalSection.permissionedWS ? subcon.generalSection.permissionedWS : [];
        // worksites = authzsWs.map(wsId => parseInt(wsId));
        const erKeyPart = employerId + '#';
        worksites = authzsWs
                        .filter(wsKeyId => wsKeyId.startsWith(erKeyPart))
                        .map(wsKeyId => parseInt(wsKeyId.split('#')[1]))
    }
    else{
        worksites = null;
    }    

    return worksites;
}


export const isUserAuthorizedForPath = (pathname) => {
    const userRole = store.getState().auth.afUser?.generalSection?.role;

    if(userRole == null) {
        return false;
    }
    else if(userRole === RoleSystem.Admin || userRole === RoleSystem.User) {
        return true;
    }
    else if(AuthRoute.authorizationRoutes.has(userRole)) {
        // replaces '/users/12' with '/users/*'
        const accessRoute = pathname.replace(/\/[0-9]+$/, '/*');
        const allowedRoutes = AuthRoute.authorizationRoutes.get(userRole);
        return allowedRoutes.includes(accessRoute);
    }
    else {
        return false;
    }
}

